var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('I18n',{attrs:{"name":"ten-translation","title":"","clearCache":false,"moduleProps":_vm.moduleProps}})}
var staticRenderFns = []

export { render, staticRenderFns }